export interface getTranxTipoCta {
    id: string;
    descripcion: string;
}

export class getTranxTipoCta implements getTranxTipoCta {
    constructor(init?: getTranxTipoCtaFormValues) {
        Object.assign(this, init);
    }
}

export class getTranxTipoCtaFormValues {
    id: string = "";
    descripcion: string ="";

    constructor(getTranxTipoCta?: getTranxTipoCtaFormValues) {
        if (getTranxTipoCta) {
            this.id = getTranxTipoCta.id;
            this.descripcion = getTranxTipoCta.descripcion;
        }

    }
}

export interface getTranx {
    id: string;
    transacciones: string;
}

export class getTranx implements getTranx {
    constructor(init?: getTranxFormValues) {
        Object.assign(this, init);
    }
}

export class getTranxFormValues {
    id: string = "";
    transacciones: string ="";

    constructor(getTranx?: getTranxFormValues) {
        if (getTranx) {
            this.id = getTranx.id;
            this.transacciones = getTranx.transacciones;
        }

    }
}